/**
 * 搜索页相关的打点
 */

export default {
  /**
   * 搜索结果页面点击
   * @param {*} click
      comprehensive|综合tab点击;
      skillvideo|技巧视频tab点击;
      skillqa|技巧问答tab点击;
      skillarticle|技巧文章tab点击;
      more|查看更多;
      nofind|未找到搜索结果上报;
      content|点击内容;
      noresult:搜索无结果时点击上报搜索词按键点击上报
      number:搜索结果所处的条目排序（点击搜索结果时上报）
   * @param {*} area 搜索结果页-综合页面-展示区域上报
      skillvideo|技巧视频;
      skillqa|技巧问答;
      skillarticle|技巧文章;
   * @param {*} type 教程id
   * @param {*} searchkey 搜索关键词
   * @param {*} policy 向量召回结果点击
      A|正常返回，接口透传的Policy标识为A
      G|50%用户展示无结果页，接口透传的Policy标识为G
      F|50%用户采用向量召回策略，展示搜索结果，按接口透传的Policy标识为F"
   */
  searchpageResultClick({
    click,
    sort,
    form,
    type,
    searchkey,
    policy,
    number,
  }) {
    this.collect('searchpage_result_click', {
      click,
      sort,
      form,
      type,
      searchkey,
      policy,
      number,
    });
  },

  /**
   * 搜索结果页面展示
   * @param {*} result 搜索结果是否有结果上报
      yes|有结果;
      no|无结果; 
   * @param {*} searchkey 上报搜索关键词
   * @param {*} area 搜索结果页-综合页面-展示区域上报
      skillvideo|技巧视频;
      skillqa|技巧问答;
      skillarticle|技巧文章;
   * @param {*} source 搜索结果页面各tab页面展示上报
      comprehensive|综合tab;
      skillvideo|技巧视频;
      skillqa|技巧问答;
      skillarticle|技巧文章;
    * @param {*} policy 向量召回结果点击
      A|正常返回，接口透传的Policy标识为A
      G|50%用户展示无结果页，接口透传的Policy标识为G
      F|50%用户采用向量召回策略，展示搜索结果，按接口透传的Policy标识为F"
   */
  searchpageResultShow({ result, searchkey, source, policy, form }) {
    // 兼容传入布尔值或者0的情况
    if (typeof result !== 'string') {
      result = result ? 'yes' : 'no';
    }
    this.collect('searchpage_result_show', {
      result,
      searchkey,
      source,
      policy,
      form,
    });
  },
};
